export const getWorkoutSetScope = (setId, context = {}) => {
  const activityId = context.workoutId != null ? String(context.workoutId) : '';
  const workoutExerciseId = context.workoutExerciseId != null ? String(context.workoutExerciseId) : '';
  const normalizedSetId = setId != null ? String(setId) : '';
  if (!activityId || !workoutExerciseId || !normalizedSetId) return null;
  return { activityId, workoutExerciseId, setId: normalizedSetId };
};

export const workoutExerciseScopeKey = (workoutId, workoutExerciseId) =>
  `${String(workoutId)}:${String(workoutExerciseId)}`;

export const workoutSetScopeKey = (scope) => scope
  ? `${scope.activityId}:${scope.workoutExerciseId}:${scope.setId}`
  : null;
